import {css, view} from '@sail/ui/deprecated';
import {useUniversalHelpDotComDesign} from '../../FeatureFlagsProvider';
import {ChatBubbleDotCom} from './ChatBubbleDotCom';

type Props = {
  background: 'neutral100' | 'neutral600';
  borderTop?: string;
  children: React.ReactNode;
};

export const ChatBubble = ({
  background,
  borderTop,
  children,
}: Props): JSX.Element => {
  const useDotComDesign = useUniversalHelpDotComDesign();

  if (useDotComDesign) {
    return (
      <ChatBubbleDotCom
        background={background}
        borderTop={borderTop}
        animation="disabled"
      >
        {children}
      </ChatBubbleDotCom>
    );
  }

  return (
    <view.div
      data-testid="chat-bubble"
      css={{
        borderRadius: 'medium',
        background: css.value(`$color.${background}`),
        paddingX: 'medium',
        paddingY: 'small',
        whiteSpace: css.value('pre-line'),
        overflow: css.value('hidden'),
        borderTop: css.value(borderTop || ''),
        overflowWrap: css.value('break-word'),
        stack: 'y',
        gap: 'small',
      }}
    >
      {children}
    </view.div>
  );
};
